export function formatMoney(price) {
  return price.toLocaleString("ja-JP", { style: "currency", currency: "JPY" });
}

export function isMobile() {
  return window.matchMedia("(max-width: 801px)").matches;
}
